import {
  Button,
  Space,
  message,
  Switch
} from 'antd'
import { useState, useEffect } from 'react'
import QueryFormComponent from "../components/queryFormComponent";
import TableComponent from "../components/tableComponent";
import ModalComponent from "./components/modalComponent";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import AuthComponent from '../../../components/AuthComponent';
import service from "../../../@services";
import DeleteComponent from "./components/deleteComponent";


const SelfDelivery = () => {

  const [modalVisible, setModalVisible] = useState(false)
  const [defaultValue, setDefaultValue] = useState({})
  const [isInit, setIsInit] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deleteFormVal, setDeleteFormVal] = useState({})
  const [formVal, setFormVal] = useState({})
  const [modalData, setModalData] = useState({})
  const [delContent, setDelContent] = useState('')
  const [pageSetting, setPageSetting] = useState({
    pageIndex: 1,
    pageSize: 20
  })
  // 默认值
  const setDefault = (val) => {
    if (isInit) return
    setIsInit(true)
    setDefaultValue({ outStoreNo: [val.storeCode] })
  }
  // 查询表单
  const fields = [
    {
      label: '所属门店',
      name: 'outStoreNo',
      component: <ShopSelect OnOptionsLoad={setDefault} />
    },
  ]
  // 表格头
  const columns = [
    {
      title: '排序',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => index + 1
    },
    {
      title: '名称',
      align: 'center',
      dataIndex: "title",
    },
    {
      title: '详细地址',
      align: 'center',
      render: (row) => {
        return row.provinceName + row.cityName + row.areaName + row.address
      }
    },
    {
      title: '所属门店',
      dataIndex: 'storeName',
      key: 'storeName',
      align: 'center'
    },
    {
      title: '状态',
      align: 'center',
      render: (row) => {
        return <AuthComponent authKey="/mallSelfDelivery/updateStatus">
          <Switch defaultChecked={!!row.status} onChange={(val) => {
            service.selfDelivery.mallSelfDeliveryUpdateStatus({
              id: row.id,
              status: row.status ? 0 : 1
            }).then(res => {
              message.success(`${row.status ? '禁用' : '启用'}成功`)
              row.status = row.status ? 0 : 1
              setPageSetting({
                pageIndex: 1,
                pageSize: 20
              })
            })
          }}></Switch>
        </AuthComponent>
      }
    },
    {
      title: '更新时间',
      dataIndex: 'operTime',
      key: 'operTime',
      align: 'center'
    },
    {
      title: '更新人',
      dataIndex: 'operName',
      key: 'operName',
      align: 'center'
    },
    {
      title: '操作',
      align: 'center',
      key: "operate",
      render: (row) => (
        <Space>
          <AuthComponent authKey="/mallSelfDelivery/update">
            <Button
              type="link"
              onClick={() => handleRecommend('edit', row)}
            >编辑</Button>
          </AuthComponent>
          <AuthComponent authKey="/mallSelfDelivery/delete/{id}">
            <Button
              type="link"
              onClick={() => handleRecommend('delete', row)}
            >删除</Button>
          </AuthComponent>
        </Space>
      )
    }
  ]
  // 列表查询
  const getList = () => {
    setLoading(true)
    const params = Object.assign({}, defaultValue, formVal, pageSetting)
    if (Array.isArray(params.outStoreNo)) {
      params.outStoreNo = params.outStoreNo[0]
    }
    service.selfDelivery.mallSelfDeliveryList(params).then(res => {
      setTotal(res.recordCount)
      setList(res.result)
    }).catch(err => console.log(err)).finally(() => {
      setLoading(false)
    })
  }
  // 查询
  const searchFormFn = (val) => {
    if (!val.outStoreNo) {
      val.outStoreNo = defaultValue.outStoreNo[0]
    }
    setFormVal({ ...val })
    setPageSetting({
      pageIndex: 1,
      pageSize: 20
    })
    console.log(formVal)
  }
  // 操作合集
  const handleRecommend = (type, val) => {
    if (type === 'delete') {
      // 删除
      setDeleteFormVal(val)
      setDelContent(`确认删除 ${val.title} 自提点吗?`)
      setDeleteVisible(true)
    } else if (type === 'edit') {
      // 打开编辑
      service.selfDelivery.mallSelfDeliveryDetail(val.id).then(res => {
        setModalData(res || {})
      }).catch(err => console.log(err)).finally(() => {
        setLoading(false)
      })
      setModalTitle('编辑自提点')
      setModalVisible(true)
    } else {
      // 打开新增
      setModalTitle('新增自提点')
      setModalVisible(true)
    }
  }
  // 表单提交
  const submitModal = (val) => {
    if (list.length >= 20) return message.info("最多允许添加20个自提点")
    if (modalTitle === '新增自提点') {
      service.selfDelivery.mallSelfDeliveryCreate(val).then(() => {
        message.success('新增成功')
        setModalVisible(false)
        getList()
      }).catch(err => console.log(err))
    } else {
      service.selfDelivery.mallSelfDeliveryUpdate(val).then(() => {
        message.success('编辑成功')
        setModalVisible(false)
        getList()
      }).catch(err => console.log(err))
    }
  }
  // 删除
  const deleteFn = ({ id, outStoreNo }) => {
    service.selfDelivery.mallSelfDeliveryDelete({
      id,
      outStoreNo
    }).then(() => {
      message.success('删除成功')
      setDeleteVisible(false)
      getList()
    }).catch(err => console.log(err))
  }
  useEffect(() => {
    isInit && getList()
  }, [isInit, pageSetting])

  return (
    <div className="home-mall">
      <QueryFormComponent
        name="SelfDelivery"
        fields={fields}
        authKey={{ search: '/mallSelfDelivery/list' }}
        defaultValue={defaultValue}
        onSearch={searchFormFn}
      />
      <TableComponent
        loading={loading}
        columns={columns}
        btnName="新增"
        page={pageSetting}
        total={total}
        list={list}
        authKey={{ search: '/mallSelfDelivery/create' }}
        addRecommend={() => handleRecommend()}
        changePage={(val) => setPageSetting(val)}
      />
      <ModalComponent
        visible={modalVisible}
        title={modalTitle}
        modalData={modalData}
        onCancel={() => setModalVisible(false)}
        onOk={submitModal}
      />
      <DeleteComponent
        visible={deleteVisible}
        title="提示"
        content={delContent}
        onCancel={() => setDeleteVisible(false)}
        onOk={(id, outStoreNo) => deleteFn(id, outStoreNo)}
        formVal={deleteFormVal}
      />
    </div>
  )
}

export default SelfDelivery